// Debugging confirmation
console.log('✅ buildComponentBlogArticle Builder loaded successfully!');

// Home Page Builder
export async function buildContentBlogArticlePage(params) {
  console.log(
    `🏗️ buildComponentBlogArticle Builder - Starting Building buildComponentBlogArticle params ${params}`
  );

  try {
    // Parallel import of all dependencies
    const [
      { buildMasterPageByMasterLayoutBuildManager },     
      { buildComponentBlogArticle, buildComponentBlogArticleHeaderTags }     
    ] = await Promise.all([
      import(
        /* webpackChunkName:"build-manager-master-pages", webpackPrefetch: true */ '../js/build-manager-master-pages.js'
      ),     
      import(
        /* webpackChunkName:"blog-article", webpackPrefetch: true */ '../builders-components/blog/blog-article.js'
      ),
     
    ]);

    // Fetch layouts concurrently
      const [masterLayout, pageComponent, pageHeaderTags] = await Promise.all([
      buildMasterPageByMasterLayoutBuildManager('master-layout-blog'),     
      buildComponentBlogArticle(params),
      buildComponentBlogArticleHeaderTags(params),
    ]);

  

    //if (!isNodeEnvironment()) {
    // Client-side rendering structure
    const masterLayoutX = `<div id="x-my-page-layout">${masterLayout}</div>`;
      const pageContentX = `<div id="x-my-page-content">${pageComponent}</div>`;

    console.log(`🔄 buildContentBlogArticlePage Builder - Finished (Client-side)`);
    return {
      masterPageName: 'master-layout-blog',
      masterPageHtml: masterLayoutX,
      pageContentHtml: pageContentX,
      pageHeaderTags: pageHeaderTags,
    };
    //} else {
    //    // Server-side rendering
    //    const result = masterLayout.replace("{{{ content }}}", content);

    //    console.log(`🔄 buildContentBlogArticlePage Builder - Finished (Server-side)`);
    //    return result;
    //}
  } catch (error) {
    console.error('❌ Error building buildComponentBlogArticle content:', error);
    return 'Error loading buildComponentBlogArticle content.', error;
  }
}
